import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentCurrentUserEffects } from './store/tellent-current-user.effects';
import {
  TellentCurrentUserConfigToken,
  TellentCurrentUserNamespace,
  TellentCurrentUserReducer,
} from './store/tellent-current-user.store';

const provideTellentCurrentUserState = provideState(
  TellentCurrentUserNamespace,
  TellentCurrentUserReducer,
  TellentCurrentUserConfigToken,
);
const provideTellentCurrentUserEffects = provideEffects(TellentCurrentUserEffects);

export const tellentCurrentUsersData = [
  provideTellentCurrentUserState,
  provideTellentCurrentUserEffects,
];
